export default function DemoListItemController(
  $timeout,

  loaderService,
  ssDialogService,
  editNavDemoDialog,
  confirmDialog,
  alerts
) {
  const vm = this;

  vm.handleExpandListItemClick = _handleExpandListItemClick;
  vm.handleShowNavDemoClick = _handleShowNavDemoClick;
  vm.handleDeleteClick = _handleDeleteClick;

  _activate();

  function _activate() {
  }

  function _handleExpandListItemClick() {
    vm.isExpanded = !vm.isExpanded;
  }

  function _handleShowNavDemoClick($event) {
    loaderService.showViewLoader = true;
    const demo = {
      demoRadio1Items: [
        {
          name: 'Some Selection',
          id: 1,
        },
        {
          name: 'Other Selection',
          id: 2,
        },
        {
          name: 'Different Selection',
          id: 3,
        },
        {
          name: 'Last Selection',
          id: 4,
        },
      ],
      demoRadio2Items: [
        {
          name: 'Some Selection',
          id: 1,
        },
        {
          name: 'Other Selection',
          id: 2,
        },
        {
          name: 'Different Selection',
          id: 3,
        },
        {
          name: 'Last Selection',
          id: 4,
        },
      ],
      demoRadio3Items: [
        {
          name: 'Some Selection',
          id: 1,
        },
        {
          name: 'Other Selection',
          id: 2,
        },
        {
          name: 'Different Selection',
          id: 3,
        },
        {
          name: 'Last Selection',
          id: 4,
        },
      ],
      demoRadio4Items: [
        {
          name: 'Some Selection',
          id: 1,
        },
        {
          name: 'Other Selection',
          id: 2,
        },
        {
          name: 'Different Selection',
          id: 3,
        },
        {
          name: 'Last Selection',
          id: 4,
        },
      ],
      demoItems: [
        {
          name: 'List Item 1',
          associate: 'Jeff Giesler',
          date: '12/12/20',
          count: 5,
          info: 'This is some info',
          status: 'Terrible',
        },
        {
          name: 'List Item 2',
          associate: null,
          date: null,
          count: 0,
          info: 'This is some more info',
          status: 'Great',
        },
        {
          name: 'List Item 3',
          associate: 'John Rittelmeyer',
          date: '11/11/20',
          count: 8,
          info: null,
          status: 'Good',
        },
      ],
      selection1Items: [
        {
          selection1ItemId: 1,
          name: 'An Option',
        },
        {
          selection1ItemId: 2,
          name: 'Another Option',
        },
        {
          selection1ItemId: 3,
          name: 'A Different Option',
        },
        {
          selection1ItemId: 4,
          name: 'Yet Another Option',
        },
        {
          selection1ItemId: 5,
          name: 'And Another Option',
        },
        {
          selection1ItemId: 6,
          name: 'The Last Option',
        },
      ],
      selection2Items: [
        {
          selection1ItemId: 1,
          name: 'An Option',
        },
        {
          selection1ItemId: 2,
          name: 'Another Option',
        },
        {
          selection1ItemId: 3,
          name: 'A Different Option',
        },
        {
          selection1ItemId: 4,
          name: 'Yet Another Option',
        },
        {
          selection1ItemId: 5,
          name: 'And Another Option',
        },
        {
          selection1ItemId: 6,
          name: 'The Last Option',
        },
      ],
      selection3Items: [
        {
          selection1ItemId: 1,
          name: 'An Option',
        },
        {
          selection1ItemId: 2,
          name: 'Another Option',
        },
        {
          selection1ItemId: 3,
          name: 'A Different Option',
        },
        {
          selection1ItemId: 4,
          name: 'Yet Another Option',
        },
        {
          selection1ItemId: 5,
          name: 'And Another Option',
        },
        {
          selection1ItemId: 6,
          name: 'The Last Option',
        },
      ],
      tabs: [
        {
          name: 'Tab 1',
          status: 'pending',
          completedCount: 1,
          totalCount: 5,
        },
        {
          name: 'Tab 2',
          status: 'neutral',
          completedCount: 0,
          totalCount: 3,
        },
        {
          name: 'Tab 3',
          status: 'good',
          completedCount: 5,
          totalCount: 5,
        },
        {
          name: 'Tab 4',
          status: 'good',
          completedCount: 3,
          totalCount: 3,
        },
      ],
      demoNavItems: [
        {
          demoNavItemId: 1,
          name: 'Demo Nav Item 1',
          readyToSubmit: true,
        },
        {
          demoNavItemId: 2,
          name: 'Demo Nav Item 2',
          readyToSubmit: false,
        },
        {
          demoNavItemId: 3,
          name: 'Demo Nav Item 3',
          readyToSubmit: false,
        },
        {
          demoNavItemId: 4,
          name: 'Demo Nav Item 4',
          readyToSubmit: true,
        },
      ],
    };
    ssDialogService.dialogs.demo.editNavDemoDialog = ssDialogService.alert(
      editNavDemoDialog.getOptions($event, {
        demo,
      })
    );
    loaderService.showViewLoader = false;
    ssDialogService.show(ssDialogService.dialogs.demo.editNavDemoDialog);
  }

  function _handleDeleteClick($event) {
    ssDialogService.dialogs.demo.deleteDemoDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Demo?',
        message: `Are you sure you want to delete Demo "${vm.listItem.name}"?`,
        handleYesClick: _handleConfirmDeleteClick,
        handleNoClick: _handleCancelDeleteClick,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.demo.deleteDemoDialog);
  }

  function _handleConfirmDeleteClick() {
    loaderService.showViewLoader = true;
    $timeout(
      () => {
        alerts.success(`The risk "${vm.listItem.name}" was successfully deleted.`);
        _closeDeleteDialog();
        loaderService.showViewLoader = false;
      },
      500
    );
  }

  function _handleCancelDeleteClick() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.demo.deleteDemoDialog);
  }
}

DemoListItemController.$inject = [
  '$timeout',

  'loaderService',
  'ssDialogService',
  'editNavDemoDialog',
  'confirmDialog',
  'alerts',
];
